import React from "react";
import { setToaster } from "../Toaster";
import { ToastContainer } from "react-toastify";
import { AxiosError } from "axios";
import { MakeRequest } from "../DataUtil";
import Painting from "./Painting";
import SmallSpinner from "../SmallSpinner";
import Select from "react-select";
import { getCustomStyles } from "../Utilities";
import { createStore, getStore, setStore } from "../Stores";

let filterOptions: any[] = [
  { label: "Newest", value: "Newest" },
  { label: "Unsold", value: "Unsold" },
  { label: "On Sale", value: "OnSale" },
];

interface Props {
  maxRows: number;
}

interface State {
  data: any;
  isLoading: boolean;
  noData: boolean;
  pageNumber: number;
  renderCount: number;
  lastItemId: string;
  currentData: any;
  currentPage: number;
  range: number;
  scrollY: number;
  selectedFilter: any;
}

class PaintingList extends React.Component<Props, State> {
  constructor(props: Props) {
    super(props);
    this.state = {
      data: [],
      isLoading: true,
      noData: false,
      pageNumber: 0,
      renderCount: 0,
      lastItemId: "-1",
      currentData: [],
      currentPage: 1,
      range: 0,
      scrollY: 0,
      selectedFilter: filterOptions[0],
    };
    this.handleScroll = this.handleScroll.bind(this);
    this.handleFilterChange = this.handleFilterChange.bind(this);
  }
  async loadData(): Promise<any> {
    const successCallback = (result: any): void => {
      if (result?.Success && result?.Data?.length > 0) {
        this.setState(
          {
            data: result.Data,
            noData: false,
            isLoading: false,
          },
          () => {
            this.addData(false);
          }
        );
      } else {
        this.setState({ isLoading: false, noData: true });
      }
    };
    const errorCallback = (error: AxiosError): void => {
      if (error) {
        this.setState({ isLoading: false, noData: true }, () => {
          setToaster({
            state: { error: true },
            message: error.response ? error.message : "Unknown Error",
          });
        });
      }
    };
    this.setState({ isLoading: true }, () => {
      MakeRequest({
        url: "Painting/GetPublicPaintingsOnScroll",
        method: "get",
        data: {
          querystringParams:
            "/'" +
            this.state.lastItemId +
            "'/" +
            this.props.maxRows +
            "/'" +
            this.state.selectedFilter.value +
            "'/",
        },
        successCallback,
        errorCallback,
      });
    });
  }
  addData = (clearData: boolean): void => {
    //add the new data to existing data array
    let updatedData: any = [];
    if (
      this.state.data &&
      this.state.data.length > 0 &&
      this.state.currentData.length > 0
    ) {
      updatedData = this.state.currentData;
      this.state.data.forEach((item: any) => {
        const found = this.state.currentData.find(
          (element: any) => element === item
        );
        if (found === null || found === undefined) {
          updatedData.push(item);
        }
      });
    } else if (this.state.data.length > 0) {
      updatedData = this.state.data;
    }

    if (clearData) {
      if (updatedData && updatedData.length > 0) {
        this.setState({
          data: [],
          currentData: updatedData,
        });
      }
    } else if (updatedData && updatedData.length > 0) {
      this.setState({
        currentData: updatedData,
      });
    }
    this.setState({
      isLoading: false,
    });
  };

  handleScroll = (e: any): void => {
    let scroller: any = document.getElementById("scrollable");
    let overallScrollHeight: number;
    if (scroller?.lastChild && scroller.lastChild !== undefined) {
      let rowHeight: number = scroller.lastChild.offsetHeight;
      overallScrollHeight = Math.round(
        window.innerHeight + document.documentElement.scrollTop + rowHeight
      );
    } else {
      overallScrollHeight = Math.round(
        window.innerHeight + document.documentElement.scrollTop
      );
    }

    if (
      (scroller &&
        overallScrollHeight < document.documentElement.offsetHeight) ||
      this.state.isLoading
    ) {
      return;
    }

    if (
      this.state.currentData != null &&
      this.state.currentData.length > 0 &&
      this.state.data.length > 0
    ) {
      let lastItem: any =
        this.state.currentData[this.state.currentData.length - 1];
      if (lastItem && !this.state.noData) {
        this.setState({ lastItemId: lastItem.PaintingId }, () => {
          this.loadData().then((result) => {
            if (result && result !== undefined && result.length > 0) {
              this.addData(true);
            }
          });
        });
      }
    }
  };

  handleFilterChange = (e: any) => {
    this.setState(
      { selectedFilter: e, data: [], currentData: [], lastItemId: "-1" },
      () => {
        this.loadData();
        setStore(e, "PaintingsFilter");
      }
    );
  };

  componentDidMount = () => {
    //set up the filter store
    let filterStore: any = getStore("PaintingsFilter");
    if (filterStore && filterStore !== undefined) {
      if (filterStore.length === 0) {
        filterStore = filterOptions[0];
      }
      this.setState(
        {
          selectedFilter: filterStore,
        },
        () => {
          this.loadData().then(() => {
            window.addEventListener("scroll", this.handleScroll);
          });
        }
      );
    } else {
      //create simple stores
      createStore("PaintingsFilter");
      this.loadData().then(() => {
        window.addEventListener("scroll", this.handleScroll);
      });
    }
  };
  render() {
    let paintings: any[] = [];
    if (this.state.currentData != null && this.state.currentData.length > 0) {
      paintings = this.state.currentData.map(
        (painting: any, index: number) =>
          painting.PaintingId && (
            <Painting
              key={"key_" + painting.PaintingId + "_" + index}
              PaintingId={painting.PaintingId}
              PaintingName={painting.PaintingName}
              PaintingPath={painting.PaintingPath}
              IsSold={painting.IsSold}
              Title={painting.Title}
              Medium={painting.Medium}
              Price={painting.Price}
              Size={painting.Size}
              DateCreated={painting.DateCreated}
              ThumbPath={painting.ThumbPath}
              Discount={painting.Discount}
              DiscountPrice={painting.DiscountPrice}
            />
          )
      );
    }
    return (
      <>
        <div className="container">
          <div className="row">
            <label htmlFor="filterDrp">
              <strong>Filter Options:</strong>
            </label>
            &nbsp;
            <Select
              key={"filter_" + this.state.renderCount}
              id="filterDrp"
              value={this.state.selectedFilter}
              onChange={this.handleFilterChange}
              options={filterOptions}
              styles={getCustomStyles()}
            />
          </div>
        </div>
        <hr />
        <div id="scrollable" className="row">
          {paintings}
        </div>
        <div className="center">
          <SmallSpinner isLoading={this.state.isLoading} actionText="Loading" />
        </div>
        {this.state.currentData.length === 0 && !this.state.isLoading && (
          <div className="alert alert-info">
            <div className="container">
              <span>No paintings at this time</span>
            </div>
          </div>
        )}
        <ToastContainer autoClose={2000} />
      </>
    );
  }
}

export default PaintingList;
